// import React from "react"
// import Img from 'gatsby-image'
// import { BLOCKS, MARKS, INLINES } from "@contentful/rich-text-types"
// import { documentToReactComponents } from "@contentful/rich-text-react-renderer"
// // ---------------------------------------------
// // ...
// // ---------------------------------------------

// const Bold = ({ children }) => <strong>{children}</strong>
// const Text = ({ children }) => <p>{children}</p>
// const Hyperlink = ({ data, children }) => <a href={data.uri} target="_blank" rel="noopener noreferrer">{children}</a>
// const EmbeddedAsset = ({ data }) => {

//   if (data.target.fields) {
//     const file = data.target.fields.file["en-US"]
//     const { url, details: { image} } = file
//     const { width, height } = image
//     const aspectRatio = width / height
//     const srcSet = `
//       ${url}?w=400&h=284&q=90 400w,
//       ${url}?w=800&h=569&q=90 800w,
//       ${url}?w=1600&h=1138&q=90 1600w,
//       ${url}?w=2400&h=1707&q=90 2400w,
//       ${url}?w=2880&h=2048&q=90
//     `
//     const sizes = `2880w (max-width: 1600px) 100vw, 1600px`

//     return (
//       <Img fluid={{
//         src: url,
//         srcSet: srcSet,
//         sizes: sizes,
//         aspectRatio: aspectRatio
//       }} />
//     )
//   } else {
//     return (
//       <span>Image error</span>
//     )
//   }
// }

// const options = {
//   renderMark: {
//     [MARKS.BOLD]: text => <Bold>{text}</Bold>,
//   },
//   renderNode: {
//     [BLOCKS.PARAGRAPH]: (node, children) => <Text>{children}</Text>,
//     [BLOCKS.EMBEDDED_ASSET]: (props) => <EmbeddedAsset {...props} />,
//     [INLINES.HYPERLINK]: (node, children) => <Hyperlink {...node}>{children}</Hyperlink>,
//   },
// }

// const RichText = ({ field }) => {
//   return documentToReactComponents(field.json, options)
// }

// export default RichText


// //////////////////
// /////////////////
// //////////////////
// /////////////////

import React from 'react'
import PropTypes from 'prop-types'
// import { useStaticQuery, graphql, Link } from 'gatsby'
import { BLOCKS, MARKS, INLINES } from '@contentful/rich-text-types'
import { renderRichText } from 'gatsby-source-contentful/rich-text'
import Img from 'gatsby-image'
// import Gallery from './blocks/Gallery'
// import List from './blocks/List'
// import Quote from './blocks/Quote'
// import TwoColumn from './blocks/TwoColumn'

// MARKS
const Bold = ({ children }) => <strong>{children}</strong>
const Italic = ({ children }) => <i>{children}</i>

// BLOCKS
// const P = ({ children }) => <p>{children}</p>
// const H1 = ({ children }) => <h1>{children}</h1>
// const H2 = ({ children }) => <h2>{children}</h2>
// const H3 = ({ children }) => <h3>{children}</h3>
// const H4 = ({ children }) => <h4>{children}</h4>

const Image = (props) => {

	if (props.data.target) {
		return <Img fluid={props.data.target.fluid} alt={props.data.target.title} />
	} else {
		console.log(props)
		return <span>Image error</span>
	}
}

const Hyperlink = ({ data, children }) => {
	// console.log(data);
	return (
		<a href={data.uri} target="_blank" rel="noopener noreferrer">{children}</a>
	)
}

const DownloadLink = ({ data, children }) => {
	const file = data.target && data.target.file;
	return (
		file ? (
			<a href={file.url} download={file.title} target="_blank">{children}</a>
		) : (
			<span className="c-constraints">[Asset missing]</span>
		)
	)
}

// const InlineEntry = ({ data, children }) => {
// 	console.log(data)
//   return false
// }

// const Entry = ({ data }) => {
//   console.log(data)
//   return false
// }

const options = {
  renderMark: {
    [MARKS.BOLD]: text => <Bold>{text}</Bold>,
    [MARKS.ITALIC]: text => <Italic>{text}</Italic>,
  },
  renderNode: {
    // [BLOCKS.PARAGRAPH]: (_node, children) => <P>{children}</P>,
    // [BLOCKS.HEADING_1]: (_node, children) => <H1>{children}</H1>,
    // [BLOCKS.HEADING_2]: (_node, children) => <H2>{children}</H2>,
    // [BLOCKS.HEADING_3]: (_node, children) => <H3>{children}</H3>,
    // [BLOCKS.HEADING_4]: (_node, children) => <H4>{children}</H4>,
    // [BLOCKS.QUOTE]: (node, children) => <Quote>{children}</Quote>,
    // [BLOCKS.EMBEDDED_ENTRY]: (node, children) => <EmbeddedEntry {...node}>{children}</EmbeddedEntry>,
    [BLOCKS.EMBEDDED_ASSET]: (node, children) => <Image {...node}>{children}</Image>,
    // [BLOCKS.EMBEDDED_ENTRY]: (node, children) => <Entry {...node} />,
		[INLINES.HYPERLINK]: (node, children) => <Hyperlink {...node}>{children}</Hyperlink>,
		[INLINES.ASSET_HYPERLINK]: (node, children) => <DownloadLink {...node}>{children}</DownloadLink>,
		// [INLINES.ENTRY_HYPERLINK]: (node, children) => <InlineEntry {...node}>{children}</InlineEntry>
  },
  renderText: text => text.split('\n')
    .reduce((children, textSegment, index) => [...children, index > 0 && <br key={index} />, textSegment], [])
}

const RichText = ({ content, debug }) => {

	// console.log(debug)

	return (
		content && (
			renderRichText(content, options)
		)
	)
}

RichText.propTypes = {
  content: PropTypes.shape({
		raw: PropTypes.string.isRequired,
		references: PropTypes.array
	})
}

export default RichText
